module.exports = __webpack_public_path__ + "img/logo.6053f8e6.png";